import React from 'react';
import InstagramFeed from './components/instagram/InstagramFeed';

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-3 sm:py-6 px-4 text-center">
          <h1 className="text-lg sm:text-3xl font-bold text-gray-900 tracking-wide" style={{ fontFamily: '"Libre Baskerville", serif' }}>The Dorcol Residence - IG Preview</h1>
        </div>
      </header>
      <main>
        <div className="w-full sm:max-w-7xl sm:mx-auto py-6 sm:px-6 lg:px-8">
          <InstagramFeed />
        </div>
      </main>
    </div>
  );
}

export default App;
